import React, { useEffect, useCallback, useState} from 'react';
import TokenIcon from './TokenIcon.js';
import {connect} from 'react-redux';
import {mintToken} from 'nft/mint.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const MintsToolbarView = ({mintedTokens, sequencerEngine}) => { 
    let [show, setShow] = useState(false);
    let [minting, setMinting] = useState(false);

    let ptoken = mintedTokens[0];
    const onMintClicked = useCallback(() => {
        setMinting(true);
        mintToken(ptoken.projectId).then(
            x => setMinting(false));
    }, [ptoken, setMinting]);

    if (!ptoken) {
        return '';
    }

    let unminted = ptoken.maxInvocations - mintedTokens.length;
    let {tokenId} = sequencerEngine;

    return (
        <div onClick={() => setShow(!show)} className="mints-toolbar-view no-select">
          <TokenIcon seedHash={sequencerEngine.seedHash} className={show ? "token-icon showing" : "token-icon"}/>
          {show &&
           <div
             onClick={(e) => e.stopPropagation()}
             className="minted-menu">
             <div className="project-info">
               <div className="project-title">
                 {mintedTokens[0].title}
               </div>
               <div className="project-id">{mintedTokens[0].projectId}</div>
               <div className="max-invocations">
                 Max: {mintedTokens[0].maxInvocations}
               </div>
             </div>
             <div className="minted">
             {mintedTokens.map(
                 token =>
                     <TokenOption isSelected={token.tokenId === tokenId} token={token}/>)}
             </div>
             <div className="unminted">
               {unminted} unminted tokens left
               {unminted > 0 &&
                <div
                  onClick={onMintClicked}
                  className={minting ? "mint-button minting" : "mint-button"}>
                  Mint
                </div>}
             </div>
           </div>}
        </div>
    );
};

const TokenOption = ({token, isSelected}) => {
    const goToToken = () => {
        let url = "/nft/" + parseInt(token.projectId) + "/" + token.tokenId;
        console.log('project url', url);
        window.location.href = url;
    };

    let className="token-option";
    if (isSelected) {
        className += " selected";
    }
    return (
        <div
          onClick={goToToken}
          className={className}>
          <TokenIcon seedHash={token.seedHash}/>
          <div className="token-id">{token.tokenId}</div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      mintedTokens: state.nft.mintedTokens
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MintsToolbarView);
